import { Button } from './Button';
import { cn } from '@/lib/cn';

type PaginationBarProps = {
  page: number;
  totalPages: number;
  total: number;
  onPrev: () => void;
  onNext: () => void;
  summary?: string;
  className?: string;
};

export function PaginationBar({
  page,
  totalPages,
  total,
  onPrev,
  onNext,
  summary,
  className,
}: PaginationBarProps) {
  if (total <= 0) return null;

  return (
    <div className={cn('mt-6 flex flex-col items-center gap-3 sm:flex-row sm:justify-between', className)}>
      {summary ? <p className="order-2 text-center text-xs text-slate-500 sm:order-1 sm:text-left">{summary}</p> : null}
      <div className="order-1 flex w-full max-w-md items-center justify-center gap-2 sm:order-2 sm:w-auto sm:max-w-none">
        <Button
          variant="secondary"
          size="sm"
          className="min-h-11 min-w-[5.5rem] sm:min-h-0 sm:min-w-0"
          disabled={page <= 1}
          onClick={onPrev}
        >
          上一页
        </Button>
        <span className="min-w-[5rem] flex-1 text-center text-sm tabular-nums text-slate-600 sm:flex-initial">
          {page} / {totalPages}
        </span>
        <Button
          variant="secondary"
          size="sm"
          className="min-h-11 min-w-[5.5rem] sm:min-h-0 sm:min-w-0"
          disabled={page >= totalPages}
          onClick={onNext}
        >
          下一页
        </Button>
      </div>
    </div>
  );
}
